// extracted by mini-css-extract-plugin
export default {"container":"StaticImage-module--container--sRv01"};